import {Module} from "module/Module";
import {UrlParamReducerNS} from "module/UrlParam/reducer/UrlParamReducer";

export const UrlParamModule: Module = {
	reducerNS: UrlParamReducerNS,
}